module.exports = __webpack_public_path__ + "img/click_tab2.97da1a8a.png";